module.exports = __webpack_public_path__ + "static/media/10quanmeitikefu2.67f9b789.png";